// AccountNotificationsSkeleton.jsx
import React from "react";
import "./accountNotificationsSkeleton.css";

const AccountNotificationsSkeleton = () => {
	return (
		<div className="sf-account-notifications-page">

			{/* TITLE */}
			<div className="sf-skel-line shimmer w-50 sf-skel-page-title"></div>

			{/* PUSH SECTION TITLE */}
			<div className="sf-skel-line shimmer w-30 sf-skel-section-label"></div>

			{/* PUSH CTA CARD */}
			<div className="sf-notification-push-cta sf-skel-card">
				<div className="sf-skel-btn shimmer"></div>
				<div className="sf-skel-line shimmer w-70"></div>
			</div>

			{/* NOTIFICATION BLOCKS */}
			{Array.from({ length: 2 }).map((_, i) => (
				<div key={i} className="sf-notification-block sf-skel-card">
					
					{/* Block title */}
					<div className="sf-skel-line shimmer w-40 sf-skel-block-title"></div>

					{/* Rows */}
					{Array.from({ length: 2 }).map((_, j) => (
						<div key={j} className="sf-skel-notification-item">
							
							<div className="sf-skel-line shimmer w-60"></div>

							<div className="sf-skel-toggle-row">
								<div className="sf-skel-channel shimmer"></div>
								<div className="sf-skel-channel shimmer"></div>
							</div>

						</div>
					))}
				</div>
			))}

		</div>
	);
};

export default AccountNotificationsSkeleton;
